// Generated by ReScript, PLEASE EDIT WITH CARE


var mode = process.env.REACT_APP_STAGE;

var config;

switch (mode) {
  case "prod" :
      var workflow = "prod";
      config = {
        workflow: workflow,
        url: "https://oi50vwyvp7.execute-api.ap-southeast-1.amazonaws.com/prod",
        liff: {
          liff_id: "1656057767-lZ6Dp7Pa",
          workflow: workflow,
          auth: {
            is_web: false,
            mock: {
              access_token: ""
            }
          }
        }
      };
      break;
  case "staging" :
      var workflow$1 = "staging";
      config = {
        workflow: workflow$1,
        url: "https://oi50vwyvp7.execute-api.ap-southeast-1.amazonaws.com/staging",
        liff: {
          liff_id: "1656154391-2KxP4wER",
          workflow: workflow$1,
          auth: {
            is_web: false,
            mock: {
              access_token: ""
            }
          }
        }
      };
      break;
  default:
    var workflow$2 = "dev";
    config = {
      workflow: workflow$2,
      url: "https://oi50vwyvp7.execute-api.ap-southeast-1.amazonaws.com/dev",
      liff: {
        liff_id: "1656089186-vEjZPD2L",
        workflow: workflow$2,
        auth: {
          is_web: false,
          mock: {
            access_token: "tokendev"
          }
        }
      }
    };
}

var workflow$3 = config.workflow;

var url = config.url;

var liff = config.liff;

export {
  mode ,
  config ,
  workflow$3 as workflow,
  url ,
  liff ,
  
}
/* mode Not a pure module */
